import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";

const insights: Array<Insight> = [
    {
        id: "20251014-ihrhelden",
        datum: "14.10.2025",
        kategorie: KategorieEnum.COMMUNITY,
        type: InsightTypeEnum.FEATURE,
        title: "Bezahlte Kooperation: Exklusive Rabatte für Alltagsheld:innen",
        lizenz: [LizenzEnum.PRO, LizenzEnum.KURSE, LizenzEnum.FREE],
        content: [
            "❤️ Dein Engagement verdient mehr als ein „Danke“!",

            "Unser neuer Partner <i>ihrHelden</i> ist eine eine geschlossene Plattform speziell für alle, die täglich Großes leisten: Hilfsorganisation, Feuerwehr, medizinischer Bereich und auch Ehrenamt."
            + " Du erhältst exklusive Rabatte auf bekannte Marken, von Fashion über Technik bis hin zu Reisen. Die Registrierung ist einfach, schnell und 100% kostenlos.<br>"
            + "Wir wünschen dir viel Spaß beim Stöbern und Sparen!",

            "👉 Jetzt Vorteile entdecken: <a href='https://info.hiorg-server.de/ihrhelden' target='_blank' rel='sponsored'>https://info.hiorg-server.de/ihrhelden</a><sup>*</sup><br>"
            + "<small><sup>*</sup>Affiliate-Link / Werbung – ihr spart, wir erhalten eine kleine Provision.</small>",
        ],
        aktions: [],
    },
];

export {
    insights,
};
